import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import LazyLoadImg from 'components/lazy-load-img/LazyLoadImg';
import VideoPlayer from 'components/video-player/VideoPlayer';

import {
  findElementInGroups,
  findNearestElements
} from 'modules/select-story-snippets/utils/general';

import { GroupedByDate, StorySnippet } from 'modules/select-story-snippets/types';

import './select-story-snippets-video-player.scss';

interface Props {
  snippets: GroupedByDate<StorySnippet>,
  previewSnippetCode: string,
  onRequestSnippetPreview: (code: string) => void
}

const WIDTH = 210;
const HEIGHT = 372;

const SelectStorySnippetsVideoPlayer = ({
  snippets,
  previewSnippetCode,
  onRequestSnippetPreview
}: Props): null | JSX.Element => {
  const snippet = findElementInGroups(snippets, previewSnippetCode);
  const [prev, next] = findNearestElements(snippets, previewSnippetCode);

  if (snippet === null) {
    return null;
  }

  return (
    <div className="select-story-snippets-video-player">
      <span
        className={classnames('select-story-snippets-video-player__arrow', {
          'select-story-snippets-video-player__arrow--left': true
        })}
      >
        <SVGDynamicIcon
          name="chevron-left-custom-fg"
          width={8}
          height={15}
          customColor="grey"
          disabled={prev === null}
          clickable={prev !== null}
          onClick={() => {
            if (prev === null) {
              return;
            }

            onRequestSnippetPreview(prev);
          }}
        />
      </span>
      {snippet.videoUrl ? (
        <VideoPlayer
          key={snippet.code}
          height={HEIGHT}
          width={WIDTH}
          videoUrl={snippet.videoUrl}
          posterImgUrl={snippet.imageUrl}
        />
      ) : (
        <div style={{ width: WIDTH, height: HEIGHT }}>
          <LazyLoadImg
            className="select-story-snippets-video-player__image-placeholder"
            key={snippet.code}
            src={snippet.imageUrl}
            alt={snippet.takenAt}
          />
        </div>
      )}
      <span
        className={classnames('select-story-snippets-video-player__arrow', {
          'select-story-snippets-video-player__arrow--right': true
        })}
      >
        <SVGDynamicIcon
          name="chevron-right-custom-fg"
          width={8}
          height={15}
          customColor="grey"
          disabled={next === null}
          clickable={next !== null}
          onClick={() => {
            if (next === null) {
              return;
            }

            onRequestSnippetPreview(next);
          }}
        />
      </span>
    </div>
  );
};

export default SelectStorySnippetsVideoPlayer;
